import { FunctionComponent, ReactNode } from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import { mediaScreen } from '../../utils/mediaScreen';
import { Col, Row } from '../responsive';

export const Jobs: FunctionComponent<{ header: ReactNode }> = ({ header }) => {
  const { data: positions } = useQuery('jobsQuery', () => getJobs());

  if (!positions?.length) {
    return null;
  }

  return (
    <>
      {header}

      <Container className="jobs">
        <h4>OPEN ROLES</h4>

        <Row>
          {positions?.map(({ id, joblink, title, remote, city, state }) => {
            return (
              <Col xs={12} md={6} key={id}>
                <Position href={joblink} target="_blank">
                  <h3>{title}</h3>
                  <span>
                    {remote ? 'Remote, Anywhere' : `${city}, ${state}`}
                  </span>
                </Position>
              </Col>
            );
          })}
        </Row>
      </Container>
    </>
  );
};

async function getJobs(): Promise<IJob[]> {
  const res = await fetch('/api/jobs');
  return res.json();
}

const Container = styled.div`
  h4 {
    color: ${(props) => props.theme.colors.teal};
    font-size: 12px;
    margin: 0;
    margin-bottom: 32px;
  }

  ${mediaScreen('md')} {
    > div > div:nth-child(odd) {
      padding-right: 50px;
    }

    > div > div:nth-child(even) {
      padding-left: 50px;
    }
  }
`;

const Position = styled.a`
  display: block;
  text-decoration: none;
  cursor: pointer;
  color: white;
  margin-bottom: 90px;

  &:hover > h3 {
    text-decoration: underline;
  }

  h3 {
    margin: 0;
    margin-bottom: 10px;
    font-size: 30px;
  }

  span {
    font-size: 20px;
    line-height: 28px;
  }

  ${mediaScreen('xs', 'md')} {
    margin-bottom: 40px;

    h3 {
      font-size: 20px;
    }

    span {
      font-size: 14px;
    }
  }
`;

interface IJob {
  id: string;
  title: string;
  joblink: string;
  remote: boolean;
  city: string;
  state: string;
}
